import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JobV1Model, JobClient } from 'src/app/api/client';
import { ModalModule, FormLabelModule } from 'wspowerpack';
import { FormRepoService } from '../services/form-repo.service';

@Component({
  selector: 'app-employee-skilllevels-selector-modal',
  standalone: true,
  imports: [CommonModule, ModalModule, ReactiveFormsModule, FormLabelModule],
  templateUrl: './employee-skilllevels-selector-modal.html',
  styleUrls: ['./employee-skilllevels-selector-modal.scss']
})
export class EmployeeSkillLevelsSelectorModalComponent {
  @Output() submitCompletedEvent = new EventEmitter();
  
  selectorForm = this.formRepoService.selectEmployeeSkillLevelsForm();
  constructor(
    public activeModal: NgbActiveModal,
    private formRepoService: FormRepoService,
  ) {}

  ngOnInit(): void {
  }

  onConfirm(): void {
    if (this.selectorForm.invalid) {
      return;
    }



    this.submitCompletedEvent.emit(this.selectorForm);
    this.activeModal.close();
  }

  onCancel(): void {
    this.activeModal.close();
  }
}